export default "\r\n> [!INFO]\r\n> \r\n> tags:  #🕸️/🟧️   \r\n> References:   \r\n> Links: \r\n\r\n\r\n### `= this.file.name`\r\n \r\nLIST ALL FILES HERE\r\n";